import { cn } from "@/lib/utils";

export const RequirementBadge = ({
  className,
  required,
}: {
  className?: string;
  required: boolean;
}) => (
  <span
    className={cn(
      "rounded px-1.5 py-0.5 font-medium text-[10px] leading-relaxed",
      required
        ? "bg-destructive text-destructive-foreground"
        : "bg-muted-foreground text-background",
      className,
    )}
  >
    {required ? "必須" : "任意"}
  </span>
);
